import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '@core/services/session.service';

@Component({
  selector: 'app-auth',
  imports: [],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss',
  standalone: true,
})
export class AuthComponent {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private session: SessionService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const token = params['token'];

      if (token) {
        this.session.saveSession(token);
      }

      this.router.navigateByUrl('/coinflip');
      // eslint-disable-next-line no-self-assign
      window.location.href = `${window.location.origin}/coinflip`;
    });
  }
}
